import { Beneficjent } from '../../../shared/models/beneficjent';
import { FormControl, FormGroup } from '@angular/forms';
import { EditBeneficiaryFormModel } from './edit-beneficiary-form.model';
import { BeneficiaryDetailsFormBuilder } from '../../../shared/components/beneficiary/form-beneficiary-details/form-group/beneficiary-details.form.builder';
import { BeneficiaryContactDetailsFormBuilder } from '../../../shared/components/beneficiary/form-contact-details/form-group/beneficiary-contact-details.form.builder';
import { EditBeneficiaryAddressFormBuilder } from '../components/form-edit-beneficiary-address/form-group/edit-beneficiary-address.form.builder';
import { BankAccountFormBuilder } from '../../../shared/components/bank-account-number/form-bank-account/form-group/bank-account.form.builder';

export class EditBeneficiaryFormBuilder {
  public static createFormGroup(
    beneficjent: Beneficjent,
  ): FormGroup<EditBeneficiaryFormModel> {
    return new FormGroup<EditBeneficiaryFormModel>({
      id: new FormControl(beneficjent?.id),
      details: BeneficiaryDetailsFormBuilder.createFormGroup(beneficjent),
      contactDetails:
        BeneficiaryContactDetailsFormBuilder.createFormGroup(beneficjent),
      address: EditBeneficiaryAddressFormBuilder.createFormGroup(
        beneficjent || undefined,
      ),
      kontoBankowe: BankAccountFormBuilder.createFormGroup(
        beneficjent?.kontoBankowe || undefined,
      ),
      akceptacjaRegulaminu: new FormControl(beneficjent?.akceptacjaRegulaminu),
      akceptacjaRODO: new FormControl(beneficjent?.akceptacjaRODO),
      czyZweryfikowanyEmail: new FormControl(
        beneficjent?.czyZweryfikowanyEmail,
      ),
    });
  }

  public static setAvailabilityOfBankAccount(
    formGroup: FormGroup<EditBeneficiaryFormModel>,
    onInit: boolean,
  ): void {
    if (formGroup?.controls.kontoBankowe.controls.isBankAccount.value) {
      EditBeneficiaryFormBuilder.handleAvailabilityOfForeignBankAccount(
        formGroup,
      );
      //jeżeli wywołane już po załadowaniu formularza, ustawiamy domyślną wartość radio - FALSE
      if (!onInit) {
        formGroup?.controls.kontoBankowe.controls.isForeign.setValue(false);
      }
    } else {
      formGroup?.controls.kontoBankowe.controls.isForeign.disable();
      formGroup?.controls.kontoBankowe.controls.domesticAccount.disable();
      formGroup?.controls.kontoBankowe.controls.foreignAccount.disable();
    }
  }

  public static handleAvailabilityOfForeignBankAccount(
    formGroup: FormGroup<EditBeneficiaryFormModel>,
  ): void {
    const czyAdresZagraniczny =
      formGroup.controls.address.controls.adres.controls.czyAdresZagraniczny
        .value;
    const isBankAccount =
      formGroup.controls.kontoBankowe.controls.isBankAccount.value;

    // zmiana wywoływana tylko, jeżeli konto bankowe jest uzupełniane
    if (isBankAccount) {
      if (czyAdresZagraniczny) {
        formGroup.controls.kontoBankowe.controls.isForeign.enable({
          onlySelf: true,
          emitEvent: false,
        });
      } else {
        if (!!formGroup.controls.kontoBankowe.controls.isForeign.value) {
          formGroup.controls.kontoBankowe.controls.isForeign.setValue(false);
        }
        formGroup.controls.kontoBankowe.controls.isForeign.disable({
          onlySelf: true,
          emitEvent: false,
        });
      }
    }
  }

  public static toProfileModel(
    fg: FormGroup<EditBeneficiaryFormModel>,
    identity: Beneficjent,
  ): Beneficjent {
    const beneficjent = this.toModel(fg);
    beneficjent.imie = identity.imie;
    beneficjent.nazwisko = identity.nazwisko;
    beneficjent.pesel = identity.pesel;
    return beneficjent;
  }

  public static toModel(fg: FormGroup<EditBeneficiaryFormModel>): Beneficjent {
    const beneficjent = new Beneficjent();
    beneficjent.imie = fg.controls.details.controls.imie.value;
    beneficjent.drugieImie = fg.controls.details.controls.drugieImie.value;
    beneficjent.nazwisko = fg.controls.details.controls.nazwisko.value;
    beneficjent.pesel = fg.controls.details.controls.pesel.value;
    beneficjent.obywatelstwo = fg.controls.details.controls.obywatelstwo.value;
    beneficjent.stanCywilny = fg.controls.details.controls.stanCywilny.value;
    beneficjent.dataUrodzenia =
      fg.controls.details.controls.dataUrodzenia.value;
    beneficjent.rodzajDokumentu =
      fg.controls.details.controls.rodzajDokumentu.value;
    beneficjent.nrDokumentu = fg.controls.details.controls.nrDokumentu.value;
    beneficjent.plec = fg.controls.details.controls.plec.value;
    beneficjent.telefon1 = fg.controls.contactDetails.controls.telefon1.value;
    beneficjent.telefon2 = fg.controls.contactDetails.controls.telefon2.value;
    beneficjent.email = fg.controls.contactDetails.controls.email.value;
    beneficjent.akceptacjaRegulaminu = fg.controls.akceptacjaRegulaminu.value;
    beneficjent.akceptacjaRODO = fg.controls.akceptacjaRODO.value;
    beneficjent.czyZweryfikowanyEmail = fg.controls.czyZweryfikowanyEmail.value;
    // Mapowanie adresu
    EditBeneficiaryAddressFormBuilder.toModel(fg.controls.address, beneficjent);
    // Mapowanie konta bankowego
    beneficjent.kontoBankowe = BankAccountFormBuilder.toModel(
      fg.controls.kontoBankowe,
    );

    return beneficjent;
  }
}
